// extracted by mini-css-extract-plugin
export var layoutContainer = "_a6-0";
export var layoutContainerNoRounding = "_a6-6";
export var layoutContainerOpen = "_a6-5";
export var layoutContainerResizing = "_a6-1";
export var mainContent = "_a6-2";
export var resizeDivider = "_a6-3";
export var slidePanel = "_a6-4";